// extracted by mini-css-extract-plugin
export var about = "RehomingCentrePage-module--about--479a7";
export var aboutandpromo = "RehomingCentrePage-module--aboutandpromo--8dd15";
export var heading = "RehomingCentrePage-module--heading--6aa8b";
export var imagecaption = "RehomingCentrePage-module--imagecaption--6589a";
export var imagewrapper = "RehomingCentrePage-module--imagewrapper--2f1e8";
export var intropara = "RehomingCentrePage-module--intropara--7132f";
export var leadpara = "RehomingCentrePage-module--leadpara--a6182";
export var promosection = "RehomingCentrePage-module--promosection--51d8d";
export var rehomingcentrepage = "RehomingCentrePage-module--rehomingcentrepage--41dd9";